import { ResourceView } from "@ra-data-prisma/dataprovider";
import { gql } from "@apollo/client";

const CompanyFragment = gql`
  fragment CompanyFragment on Company {
    id
    name
    isBlocked
    carloExternalId
    carloPartnerId
    ingresId
    ingresType
    logo
    companyDefaultValues {
      id
      property
      value
    }
  }
`;

export const CompanyResource: ResourceView = {
  resource: "Company",
  fragment: {
    one: {
      type: "document",
      mode: "replace",
      doc: CompanyFragment,
    },
    many: {
      type: "document",
      mode: "replace",
      doc: CompanyFragment,
    },
  },
};
